import { cva } from '@/styled-system/css';

export const toastRootRecipe = cva({
  base: {
    display: 'inline-flex',
    paddingInline: 'Toast.padding.horz',
    paddingBlock: 'Toast.padding.vert',
    borderRadius: 'Toast',
    boxShadow: 'Toast',
    maxWidth: 'Toast.maxWidth',
  },
  variants: {
    tone: {
      info: {
        backgroundColor: 'Toast.info.bg',
        color: 'Toast.info.text',
      },
      success: {
        backgroundColor: 'Toast.success.bg',
        color: 'Toast.success.text',
      },
      warning: {
        backgroundColor: 'Toast.warning.bg',
        color: 'Toast.warning.text',
      },
      critical: {
        backgroundColor: 'Toast.critical.bg',
        color: 'Toast.critical.text',
      },
    },
  },
});
